
$(document).ready(function () {
  if ($(".type-detail").length) {

    const breadcrumbHref = $('#navigation-1 [itemprop="item"]').first().attr("href") || $('#navigation-1 meta[itemprop="item"]').attr("content") || "";
    const breadcrumbPath = breadcrumbHref ? new URL(breadcrumbHref, location.origin).pathname : "";
    const vyloucenaUrl = typeof vyloucenislevy !== "undefined" && vyloucenislevy.some((url) => breadcrumbPath === new URL(url, location.origin).pathname);

    shoptet.scripts.setCustomCallback('shoptet.modal.open', function(args) {
    $('.shipping-options-popup h1').text('Možnost a cena dopravy');
    });
    
    if($('.shipping-options').length){
      $('.shipping-options').text('Možnost a cena dopravy')
    };
    let twoImageGalleryCounter = 0;
    $(".p-info-wrapper").append($("#footer .needHelpDetail").clone());

    const finalPrice = getCurrentProductPrice() || 0;

    if (finalPrice > 5000) {
      $('.p-image-wrapper').append('<div class="customLineCalc"></div>')
      $('.customLineCalc').append($('#footer .detailItems').clone(), $("#footer .needHelpDetail").clone())
      $('.p-info-wrapper').addClass('haveCalc')
      $(".p-info-wrapper").append($("#footer .calculator").clone());
      $(".p-info-wrapper .calculator").find(".hour .tss").text(kalkulackaText);
      if (typeof navratnostCalculator === "function") {
        navratnostCalculator();
      } else {
        setTimeout(function () {
          if (typeof navratnostCalculator === "function") {
            navratnostCalculator();
          }
        }, 0);
      }
    }
    


    $(".p-info-wrapper").append($(".detailUsp").clone());
    $(".p-image-wrapper .p-image").append($(".product-top .flags-default").clone());
    $(".p-info-wrapper").append($(".p-detail-inner-header").clone());
    $(".p-info-wrapper").append('<div class="customCart"></div>');
    $('.p-final-price-wrapper').append($('.social-buttons-wrapper'))
    $(".customCart").append($(".p-final-price-wrapper").clone());
    $(".customCart").append($(".add-to-cart").clone());
    if (
    !vyloucenaUrl &&
    Number(getShoptetDataLayer('customer').groupId) !== 8 &&
    $('.p-final-price-wrapper .price-save').length === 0 &&
    $('.product-top .col-xs-12:not(.col-lg-6) .flag-discount-0').length === 0
    ){
       $('.customCart').append(`<div class="regBanner">
        <div class="text">
        <span class="tss">Cena pro podnikatele po registraci: <span class="show-tooltip question-tooltip" title="" data-original-title="${tooltipPoRegistraci}">?</span></span>
      
          <div class="innerWrap">  <span class="origPrice"></span>
      <span class="finalPrice"></span></div>
      </div>
      <a href="/registrace/" class="btn btn-secondary reg">Registrovat</a>
        </div>`);
    }
    else{
      // $('.customCart').append(`<div class="regBanner"></div>`);
    }
   

    $('.p-info-wrapper').append($('#footer .detailItems').clone());
    function updateRegBannerPrice() {
      const originalPrice = getCurrentProductPrice();
      if (Number.isNaN(originalPrice)) return;
      const discountedPrice = originalPrice * (1 - slevaPoRegistraci / 100);
      const formatPrice = function (price) {
        return typeof price.ShoptetFormatAsCurrency === "function" ? price.ShoptetFormatAsCurrency() : Math.round(price).toLocaleString("cs-CZ") + " Kč";
      };

      $(".customCart .origPrice").text(formatPrice(originalPrice));
      $(".customCart .finalPrice").text(formatPrice(discountedPrice));
    }

    updateRegBannerPrice();
    ["ShoptetVariantAvailable", "ShoptetVariantUnavailable", "ShoptetSurchargesPriceUpdated", "ShoptetSplitVariantParameterChange"].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        setTimeout(updateRegBannerPrice, 50);
      });
    });
    if ($('.p-gifts-wrapper').length) {
      $(".p-gift-name").prepend('<span class="giftInfo">Dárek ZDARMA k tomuto produktu</span>');
      $(".p-gifts-wrapper .p-gift-name > a").each(function () {
        const $giftLink = $(this);
        if ($giftLink.children(".text").length) {
          return;
        }

        const $textNodes = $giftLink.contents().filter(function () {
          return this.nodeType === Node.TEXT_NODE;
        });
        const giftText = $textNodes
          .map(function () {
            return this.nodeValue;
          })
          .get()
          .join("")
          .trim();

        $textNodes.remove();
        if (giftText) {
          $("<span>", { class: "text", text: giftText }).insertBefore($giftLink.children(".nowrap").first());
        }
      });
    }

    function initTwoImageGallery() {
      const $imageWrapper = $(".p-image-wrapper").first();
      const $image = $imageWrapper.find(".p-image").first();
      const $thumbnails = $imageWrapper.find(".p-thumbnails a.p-thumbnail");
      const $thumbnailTrack = $imageWrapper.find(".p-thumbnails-inner > div").first();
      const thumbnailSignature = $thumbnails
        .map(function () {
          return $(this).attr("href") || "";
        })
        .get()
        .join("|");

      if (!$image.length || !$thumbnailTrack.length || $thumbnails.length < 2) {
        return;
      }

      if ($image.data("twoImageGallery") === thumbnailSignature) {
        return;
      }

      if ($image.data("twoImageGallery")) {
        const $oldGallery = $image.find(".gallery-slides");
        if ($oldGallery.hasClass("slick-initialized")) {
          $oldGallery.slick("unslick");
        }
        if ($thumbnailTrack.hasClass("slick-initialized")) {
          $thumbnailTrack.slick("unslick");
        }
        $oldGallery.remove();
        $thumbnailTrack.removeClass("gallery-thumbnails-slider");
        $(window).off("resize.twoImageGallery");
      }

      $imageWrapper.addClass("haveThumbnails");
      $image.addClass("two-image-gallery");
      $image.find("#wrap, .p-secondary-image, .arrow-prev, .arrow-next").remove();
      $thumbnails.find("img").each(function () {
        const $thumbnailImage = $(this);
        ["src", "data-src"].forEach(function (attribute) {
          const imageUrl = $thumbnailImage.attr(attribute);
          if (imageUrl) {
            $thumbnailImage.attr(attribute, imageUrl.replace("/related/", "/orig/"));
          }
        });
      });
      $thumbnailTrack.empty().append($thumbnails);
      $thumbnailTrack.addClass("gallery-thumbnails-slider");

      // ZMĚNA: Použijeme <span> místo <a> a adresu uložíme do data-href
      const $gallery = $('<div class="gallery-slides"></div>');
      $thumbnails.each(function () {
        const $thumbnail = $(this);
        const $thumbnailImage = $thumbnail.find("img").first();
        const imageUrl = $thumbnail.attr("href") || "";
        const alt = $thumbnailImage.attr("alt") || "";
        $gallery.append(
          $("<span>", {
            class: "gallery-slide",
            "data-href": imageUrl,
            "data-alt": alt,
          }).append(
            $("<img>", {
              src: imageUrl,
              alt: alt,
              loading: "lazy",
            }),
          ),
        );
      });
      $image.append($gallery);
      $image.data("twoImageGallery", thumbnailSignature);

      const galleryRel = "product-gallery-" + (twoImageGalleryCounter++);

      // Zapamatovaný slide hlavní galerie PŘED otevřením colorboxu.
      // Šipky uvnitř colorboxu smí procházet fotkami v lightboxu,
      // ale nesmí mít žádný vliv na to, co je vidět v p-image na stránce.
      let gallerySlideBeforeColorbox = null;

      // Colorbox konfigurace přímo pro <span> s vlastním href čtením
      function initGalleryColorbox() {
        if (!$.fn.colorbox) {
          return false;
        }

        $gallery.find(".gallery-slide").colorbox({
          close: "Zavřít",
          current: "obrázek {current} z {total}",
          height: "80%",
          href: function () {
            return $(this).attr("data-href");
          },
          maxHeight: "80%",
          maxWidth: "1152px",
          next: "Následující",
          photo: true,
          previous: "Předchozí",
          rel: galleryRel,
          title: function () {
            return $(this).attr("data-alt") || "";
          },
          width: "90%",
          // Colorbox by při zavření standardně vracel fokus na naposledy
          // zobrazenou položku (ta se při šipkování uvnitř mění) - to je
          // jeden z kanálů, kterým by mohla "prosáknout" změna do p-image.
          returnFocus: false,
          onOpen: function () {
            gallerySlideBeforeColorbox = $gallery.hasClass("slick-initialized")
              ? $gallery.slick("slickCurrentSlide")
              : null;
          },
          onClosed: function () {
            // Bez ohledu na to, kolika fotkami uživatel v colorboxu prošel,
            // hlavní galerii na stránce natvrdo vrátíme na stav před otevřením.
            if (gallerySlideBeforeColorbox !== null && $gallery.hasClass("slick-initialized")) {
              if ($gallery.slick("slickCurrentSlide") !== gallerySlideBeforeColorbox) {
                $gallery.slick("slickGoTo", gallerySlideBeforeColorbox, true);
              }
            }
            gallerySlideBeforeColorbox = null;
          },
        });
        return true;
      }

      const initialIndex = Math.max(0, $thumbnails.index($thumbnails.filter(".highlighted").first()));

      // --- KLÍČOVÁ ZMĚNA ---
      // 1) swipeToSlide je pryč -> swipe respektuje přesně slidesToScroll: 1 (žádné "doletění" o 2 sloty)
      // 2) asNavFor propojuje obě instance nativně a spolehlivě, včetně rozdílného slidesToShow
      $gallery.slick({
        adaptiveHeight: false,
        arrows: true,
        dots: false,
        infinite: false,
        initialSlide: initialIndex,
        nextArrow: '<button type="button" class="arrow-next" aria-label="Další obrázek"></button>',
        prevArrow: '<button type="button" class="arrow-prev" aria-label="Předchozí obrázek"></button>',
        slidesToScroll: 1,
        slidesToShow: 2,
        swipe: true,
        touchMove: true,
        asNavFor: $thumbnailTrack,
      });

      $thumbnailTrack.slick({
        draggable: true,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        initialSlide: initialIndex,
        slidesToScroll: 1,
        slidesToShow: 4,
        swipe: true,
        touchMove: true,
        touchThreshold: 10,
        asNavFor: $gallery,
      });

      let thumbnailWasSwiped = false;
      $thumbnailTrack.on("touchmove.twoImageGallery", function () {
        thumbnailWasSwiped = true;
      });
      $thumbnailTrack.on("touchend.twoImageGallery", function () {
        setTimeout(function () {
          thumbnailWasSwiped = false;
        }, 300);
      });

      // Zkoušíme Colorbox inicializovat hned i v intervalu, dokud se nenačte knihovna Colorboxu
      initGalleryColorbox();
      const cboxInterval = setInterval(function () {
        if (initGalleryColorbox()) {
          clearInterval(cboxInterval);
        }
      }, 200);

      function refreshGallerySliders() {
        if ($gallery.hasClass("slick-initialized")) {
          $gallery.slick("setPosition");
        }
        if ($thumbnailTrack.hasClass("slick-initialized")) {
          $thumbnailTrack.slick("setPosition");
        }
      }

      $gallery.find("img").on("load", refreshGallerySliders);
      setTimeout(refreshGallerySliders, 300);
      $(window).on("resize.twoImageGallery", refreshGallerySliders);

      // asNavFor už samo drží oba slidery synchronizované (i při kliku na thumbnail
      // díky focusOnSelect). Tady si jen hlídáme vizuální .highlighted třídu.
      $gallery.on("afterChange.twoImageGallery", function (event, slick, currentSlide) {
        const currentIndex = currentSlide % $thumbnails.length;
        $thumbnails.removeClass("highlighted").eq(currentIndex).addClass("highlighted");
      });

      // Poznámka: ruční click handler na $thumbnails i ruční afterChange sync
      // mezi $gallery a $thumbnailTrack byly odstraněny - asNavFor + focusOnSelect
      // to řeší nativně a bez rizika zacyklení/přeskakování o více slidů.
    }

    initTwoImageGallery();
    document.addEventListener("ShoptetDOMContentLoaded", initTwoImageGallery);
    document.addEventListener("ShoptetDOMPageContentLoaded", initTwoImageGallery);

    $(".p-info-wrapper").append($(".shipping-options").clone());

   /* if ($(".parameter-dependent").length) {
      $(".parameter-dependent").each(function () {
        var $am = $(this).find(".availability-amount");
        if (!$am.length) {
          return;
        }
       // $am.attr("style", $(this).find(".availability-label").attr("style"));
        //$am.text($am.text().replace(/\(([^)]+)\)/, "$1"));
      });
    } else {
      //$(".p-info-wrapper .availability-amount").attr("style", $(".p-info-wrapper .availability-label").attr("style"));
     // $(".p-info-wrapper .availability-amount").text(
     //   $(".p-info-wrapper .availability-amount")
     //     .text()
     //     .replace(/\(([^)]+)\)/, "$1"),
    //  );
    }*/

    function updateDeliveryTimeNote() {
      if ($(".variant-list").length) return;

      var $availability = $(".p-info-wrapper .availability-value").first();
      var $label = $availability.find(".availability-label").first();
      if (!$availability.length || !$label.length) return;

      var deliveryDate = getDeliveryDateByAvailability($.trim($label.text()).toLowerCase());
      $availability.find(".delivery-time-note").remove();
      if (deliveryDate) {
        $("<span>", {
          class: "delivery-time-note",
          text: formatDeliveryDate(deliveryDate) + " u Vás",
        })
          .attr("style", $label.attr("style") || "")
          .appendTo($availability);
      }
    }

    updateDeliveryTimeNote();
    // Shoptet po hydrataci znovu vykreslí p-info-wrapper a poznámku smaže, proto ji doplňujeme i se zpožděním
    document.addEventListener("ShoptetDOMContentLoaded", updateDeliveryTimeNote);
    document.addEventListener("ShoptetDOMPageContentLoaded", updateDeliveryTimeNote);
    setTimeout(updateDeliveryTimeNote, 1000);

    $('.shp-tab[data-testid="tabDescription"] a').text("Popis produktu");
    $('.shp-tab[data-testid="tabDescription"]').addClass('open');
    $("#description").addClass("active in");
    $(".basic-description").addClass("open");
    
    $('li[data-testid="tabDescription"] a').on("click", function (e) {
      e.preventDefault();
      $("#tab-content > div").removeClass("active in");
      $("#description").addClass("active in");
      $('li[data-testid="tabDescription"]').toggleClass("open");
      $(".basic-description").toggleClass("open");
    });
    if ($("#productsAlternative").length) {
      $('a[href="#productsAlternative"]').text("Podobné produkty").closest("li").addClass("podobneProdukty");
      if ($("#productsAlternative .products-alternative-header").length === 0) {
        $("#productsAlternative").prepend('<div class="products-alternative-header h4">Podobné produkty</div>');
      }
      function initAlternativeProductsSlider() {
        $("#productsAlternative .products").each(function () {
          const $productsBlock = $(this);
          const $heading = $productsBlock.prevAll(".products-alternative-header").first();

          if ($productsBlock.hasClass("slick-initialized")) {
            $productsBlock.slick("setPosition");
            return;
          }

          $productsBlock.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            appendArrows: $heading.length ? $heading : $productsBlock,
            infinite: false,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 1200,
                settings: { slidesToShow: 3, slidesToScroll: 1 },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3,
                  appendArrows: $productsBlock,
                  dots: true,
                },
              },
              {
                breakpoint: 550,
                settings: {
                  slidesToShow: 2,
                  dots: true,
                },
              },
            ],
          });
          if (typeof watchProductsSliderArrows === "function") {
            watchProductsSliderArrows($productsBlock, $heading);
          }
        });
      }

      $('a[href="#productsAlternative"]').click(function (e) {
        e.preventDefault();
        $("#tab-content > div").removeClass("active in");
        $("#productsAlternative").toggleClass("active in");
        setTimeout(initAlternativeProductsSlider, 500);
      });

      $("#productsAlternative").before('<li class="productsAlternative shp-tab ed added"><button >Podobné produkty</button></li>');
      $("li.productsAlternative.shp-tab.ed.added button").on("click", function (e) {
        var isOpen = $("#productsAlternative").hasClass("active");

        $("#tab-content > div").removeClass("open active in");
        $("#p-detail-tabs > li, li.productsAlternative.shp-tab.ed.added").removeClass("open active");

        if (!isOpen) {
          $("li.productsAlternative.shp-tab.ed.added").addClass("open");
          $("#productsAlternative").addClass("open active in");
          setTimeout(initAlternativeProductsSlider, 500);
        }
      });
    }

    if ($(".extended-description").length) {
      $("#tab-content").append($(".extended-description").clone().attr("id", "extended-description").addClass("tab-pane fade"));
      $("#extended-description").before('<li class="extended-description shp-tab ed added"><button >Technické parametry</button></li>');
      $("#p-detail-tabs").append('<li class="shp-tab extended-description"><a class="extended-description">Technické parametry</a></li>');

      $("li.extended-description.shp-tab a").on("click", function (e) {
        e.preventDefault();
        $("#tab-content > div").removeClass("active in");
        $("#extended-description").toggleClass("active in");
      });
      $("li.extended-description.shp-tab.ed.added button").on("click", function (e) {
        var isOpen = $("#extended-description").hasClass("active");

        $("#tab-content > div").removeClass("open active in");
        $("#p-detail-tabs > li, li.extended-description.shp-tab.ed.added").removeClass("open active");

        if (!isOpen) {
          $("li.extended-description.shp-tab.ed.added").addClass("open");
          $("#extended-description").addClass("open active in");
        }
      });
    }

    const $returnsPanel = $("<div class='vraceniReklamace'></div>").attr("id", "vraceniReklamace").addClass("tab-pane fade");
    $returnsPanel.append('<div class="h2">Vrácení a reklamace</div>');
    $("#tab-content").append($returnsPanel);
    const returnsCacheKey = "returns-complaints-content";
    const cachedReturnsContent = localStorage.getItem(returnsCacheKey);

    function renderReturnsContent(content) {
      if (content) {
        $returnsPanel.append(content);
      }
    }

    if (cachedReturnsContent) {
      renderReturnsContent(cachedReturnsContent);
    } else {
      $.ajax({
        url: reklamaceUrl,
        type: "GET",
        success: function (response) {
          const $content = $(response).find(".pageArticleDetail > div").first();
          if (!$content.length) return;

          const contentHtml = $content.prop("outerHTML");
          renderReturnsContent(contentHtml);
          localStorage.setItem(returnsCacheKey, contentHtml);
        },
      });
    }
    $("#vraceniReklamace").before('<li class="vraceniReklamace shp-tab ed added"><button >Vrácení zboží a reklamace</button></li>');
    $("#p-detail-tabs").append('<li class="shp-tab vraceniReklamace"><a class="vraceniReklamace">Vrácení zboží a reklamace</a></li>');

    $("li.vraceniReklamace.shp-tab a").on("click", function (e) {
      e.preventDefault();
      $("#tab-content > div").removeClass("active in");
      $("#vraceniReklamace").toggleClass("active in");
    });
    $("li.vraceniReklamace.shp-tab.ed.added button").on("click", function (e) {
      var isOpen = $("#vraceniReklamace").hasClass("active");

      $("#tab-content > div").removeClass("open active in");
      $("#p-detail-tabs > li, li.vraceniReklamace.shp-tab.ed.added").removeClass("open active");

      if (!isOpen) {
        $("li.vraceniReklamace.shp-tab.ed.added").addClass("open");
        $("#vraceniReklamace").addClass("open active in");
      }
    });
  }
});
